export const ExternalTickets = [
  { label: 'Request to create a new shipment', value: 'request_to_create_a_new_shipment' },
  { label: 'Request to create a new container', value: 'request_to_create_a_new_container' },
]

export const ExternalShipmentTickets = [{ label: 'Request to create a new shipment', value: 'request_to_create_a_new_shipment' }]
export const ExternalContainerTickets = [{ label: 'Request to create a new container', value: 'request_to_create_a_new_container' }]
